import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=55c1bd60&scoped=true&lang=pug&"
import script from "./Explanation.vue?vue&type=script&lang=ts&"
export * from "./Explanation.vue?vue&type=script&lang=ts&"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=55c1bd60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1bd60",
  null
  
)

export default component.exports